import React, { useEffect } from 'react';
import { ImageLogo } from '../../../assets/images';
import useScrollPosition from '@react-hook/window-scroll';

function MainNavbar({ fixed = true }) {

  const scrollY = useScrollPosition(60 /*fps*/);

  return (
    <div id="MainNavbar" className={`${fixed && 'nav-fixed'} ${scrollY > 260 && 'nav-background'}`}>
      <a href="#" className="logo">
        <img src={ImageLogo} alt="logo" />
      </a>
      <div className="action">
        <ListGroup title="Home" link="#" active={true} />
        <ListGroup title="Our Work" link="#" />
        <ListGroup title="About" link="#" />
        <ListGroup title="Contact" link="#" />
      </div>
    </div>
  );
}

const ListGroup = ({ title, link, active }) => {
  return (
    <div className="list-group">
      <a href={link} className={`list-link ${active && 'list-link-active'}`}>{title}</a>
      { active && <div className="active-line" /> }
    </div>
  )
}

export default MainNavbar;